import _filter from 'lodash/filter';
import _uniqBy from 'lodash/uniqBy';
import _find from 'lodash/find';
import moment from 'moment';

const NYC_CITY_ID = 'aa211bf5d25100ac';
const BOSTON_CITY_ID = '301072f4d252999a';
const CHICAGO_CITY_ID = '11abc446a23da51a';
const FOXWOODS_CITY_ID = '568778505711d1b2';
const FORT_LAUDERDALE = '386597775b2a72b6';
const LA_CITY_ID = 'f9fce97fa9132e52';
const MIAMI_CITY_ID = '62c929d5af07ce54';
const PHILLY_CITY_ID = '9ceeab229a24e62d';
const HOUSTON_CITY_ID = 'f571681b2ff72d5c';
const PROVIDENCE_CITY_ID = '791ea86155e28a75';
const SCOTTSDALE_CITY_ID = 'bcdfa9e13bbb3f46';
const SEATTLE_CITY_ID = 'ae509095e188297c';
const TAMPA_CITY_ID = '2f15e73a5e960cf9';
// const DETROIT_CITY_ID = 'f552cfc2b2535d0e';
const SAN_ANTONIO_CITY_ID = 'cb453f5710bf9950';
// const HONOLULU_CITY_ID = '6a38221d87f63fbd';
const LAS_VEGAS_CITY_ID = 'cd2018d3f09c6ea9';
const ANAHEIM_CITY_ID = 'f0b90758fecbdbbf';
const MORGANTOWN_ID = '8b4957a1453b01c9';
// const WHISTLER_CITY_ID = '6fec4941d2c526ea';
// const ATLANTIC_CITY_CITY_ID = '647c7b01d5fc056a';
// const DALLAS_CITY_ID = '2a5304c583e1a75e';
// const LOS_ANGELES_CITY_ID = 'f9fce97fa9132e52';
const SAN_DIEGO_CITY_ID = 'b5ed38b8d630d9dc';
const SAN_FRANCISCO_CITY_ID = '5037331a71b485ee';
// const AUSTIN_CITY_ID = 'abd97a4fd8b43635';
const WASHINGTON_DC_CITY_ID = '070ac346cd2d446f';

const PROD_CURATED_LISTS_BY_CITY_ID = {
  [NYC_CITY_ID]: '27964c082f63edf6',
  [BOSTON_CITY_ID]: 'b698d874e188395b',
  [CHICAGO_CITY_ID]: '502c30150c54ccb1',
  [FOXWOODS_CITY_ID]: '5bbb6b3ce37a6270',
  [FORT_LAUDERDALE]: 'f8a96351f3182d1a',
  [LA_CITY_ID]: '33302c7aaee75be6',
  [HOUSTON_CITY_ID]: 'cecea942ec1cd83e',
  [PHILLY_CITY_ID]: '8a781784484defd8',
  [PROVIDENCE_CITY_ID]: '29b557cd3c22fa12',
  [SCOTTSDALE_CITY_ID]: '72a3784565d62c87',
  [SEATTLE_CITY_ID]: '44da9ab1ce4ec121',
  [TAMPA_CITY_ID]: 'f3c711777ed57c0b',
  [MORGANTOWN_ID]: '1ef4830869999a96',
  [MIAMI_CITY_ID]: 'd6365d210b4784dc',
  // [DETROIT_CITY_ID]: '2fd716eecc31bc55',
  [SAN_ANTONIO_CITY_ID]: 'dcb5ace52a793d33',
  // [HONOLULU_CITY_ID]: '127040a27e52bb33',
  [LAS_VEGAS_CITY_ID]: '8b4fb520b01a6684',
  [ANAHEIM_CITY_ID]: 'efa86bc09fd775ea',
  // [WHISTLER_CITY_ID]: 'aa418054c910bc88',
  // [ATLANTIC_CITY_CITY_ID]: '78c595923ea6cb5f',
  // [DALLAS_CITY_ID]: '5631a52a524f7d7d',
  // [LOS_ANGELES_CITY_ID]: '33302c7aaee75be6',
  [SAN_DIEGO_CITY_ID]: 'd60e332d10a61a98',
  [SAN_FRANCISCO_CITY_ID]: '81502583a1125aea',
  // [AUSTIN_CITY_ID]: '85586eaa6b8bfc85',
  [WASHINGTON_DC_CITY_ID]: 'bc15909d9d9ef303'
};

const EVENT_ENABLED = true;
const TODAYS_DATE = moment();
const EVENT_DATE = moment().month(9).date(31).endOf('day');

function Ctrl(
  $rootScope,
  $scope,
  $state,
  $timeout,
  $stateParams,
  $document,
  $location,
  $q,
  metaTagService,
  utilsService,
  jsSdkUser,
  tlEE,
  jsSdkCuratedList,
  jsSdkCuratedListFollow,
  jsSdkCity,
  imgix
) {
  //eslint-disable-line

  $scope.saving = false;
  $scope.curatedList = null;
  $scope.items = [];
  $scope.currentVenueFilter = null;
  $scope.cityForm = {};

  const PROD_CITY_IDS = Object.keys(PROD_CURATED_LISTS_BY_CITY_ID);

  const citySlug = $stateParams.city || utilsService.defaultCitySlug();

  // ---------------------- //
  $scope.showCountdown = !EVENT_ENABLED;

  const diff = TODAYS_DATE.diff(EVENT_DATE, 'days');

  if (diff > 0) {
    EVENT_DATE.add(1, 'year');

    $scope.eventPast = true;
  }

  $scope.eventDate = EVENT_DATE;
  // ---------------------- //

  jsSdkCity.list().then((cities) => {
    $scope.cities = _filter(cities, (city) => PROD_CITY_IDS.includes(city.id));

    $scope.cityForm.city =
      _find($scope.cities, {
        slugName: citySlug || 'nyc'
      }) || $scope.cities[0];

    $scope.selectCity();
  });

  $scope.selectCity = function () {
    if (PROD_CURATED_LISTS_BY_CITY_ID[$scope.cityForm.city.id]) {
      return _loadCuratedList(
        PROD_CURATED_LISTS_BY_CITY_ID[$scope.cityForm.city.id]
      );
    }

    return null;
  };

  $scope.imgix = function (src) {
    const options = {
      width: 1200,
      height: 700
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };

  $scope.toggleCurrentVenue = function (venue) {
    if (
      $scope.currentVenueFilter &&
      $scope.currentVenueFilter.id === venue.id
    ) {
      $scope.currentVenueFilter = null;
    } else {
      $scope.currentVenueFilter = venue;
    }
  };

  $scope.filterByCurrentVenue = function (item) {
    if (!$scope.currentVenueFilter) {
      return true;
    } else if ($scope.currentVenueFilter.id === item.venue.id) {
      return true;
    }

    return false;
  };

  function _loadCuratedList(id, next) {
    $scope.loading = true;

    const options = {
      items: true,
      follow: true,
      fields: [
        'venue(id, name)',
        'event(id, name, date, images, primaryImage, dateStart, dateEnd)'
      ].join(',')
    };

    jsSdkCuratedList
      .readById(id, options)
      .then((resp) => {
        $scope.curatedList = resp;
        $scope.items = resp.items;

        const eventItems = _filter($scope.items, {
          type: 'EVENT'
        });

        $scope.venues = _uniqBy(
          eventItems.map((item) => item.venue),
          (venue) => venue.id
        );

        metaTagService.set({
          title: resp.title,
          description: resp.description,
          facebookImage: resp.imageUrl
        });

        $scope.shareBarConfig = {
          url: utilsService.createUrl(`/list/${$scope.curatedList.id}`),
          message: `See Tablelist's - ${$scope.curatedList.title}`
        };

        const url = utilsService.createUrl(`/list/${$scope.curatedList.id}`);
        const msg = `See Tablelist's - ${$scope.curatedList.title}`;

        $scope.facebookLink = utilsService.facebookLink(url);
        $scope.twitterLink = utilsService.twitterLink(url, msg);
        $scope.emailLink = utilsService.mailtoLink(url, msg);

        if (next) next();

        $scope.loading = false;
        $scope.saving = false;
      })
      .catch(() => {
        $scope.loading = false;
        $scope.saving = false;
      });
  }
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  '$state',
  '$timeout',
  '$stateParams',
  '$document',
  '$location',
  '$q',
  'metaTagService',
  'utilsService',
  'jsSdk.user',
  'tl.ee',
  'jsSdk.curatedList',
  'jsSdk.curatedListFollow',
  'jsSdk.city',
  'jsSdk.imgix',
  'loggerService',
  'trackingService',
  'tl.config',
  'modalService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/curatedListsHalloween/curatedListsHalloweenCtrl.js